<template>
  <div class="pp-grid-container pp-grid-container--blog notfound">
    <div class="article__view">
      <div class="article__heading-container">
        <h2 class="article__heading">Not found</h2>
      </div>
      <p>
        Apologies, but the page you requested could not be found.
      </p>
      <p v-if="false">
        Click <a href="/">here</a> to view our latest blog entries.
      </p>
    </div>
  </div>
</template>
<script>
export default {
  props: ['desktop', 'content', 'loading'],
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

</style>
